// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const fi: KnowledgePagesCopy = {
  knowledgePage: 'Tietosivu',
  knowledgePages: 'Tietosivut',
  featureOffTitle: 'Tietosivut eivät ole käytössä tässä työtilassa.',
  featureOffBody: 'Yrityksen taustatiedot ja lähteet löytyvät yhä kohdasta Tietämys.',
  loadingPage: 'Ladataan sivua…',
  loadingSuggestion: 'Ladataan ehdotusta…',
  cancel: 'Peruuta',
  tryAgain: 'Yritä uudelleen',
  everyoneIn: 'Koko {company}',
  yourCompany: 'yrityksesi',
  revision: 'Versio {n}',
  openRevision: 'Avaa versio {n}',
  pageCount: 'one:sivu|other:sivua',
  topicCount: 'one:aihe|other:aihetta',
  sectionCount: 'one:osio|other:osiota',
  lineCount: 'one:rivi|other:riviä',
  documentCount: 'one:dokumentti|other:dokumenttia',
  changeCount: 'one:muutos|other:muutosta',
  newPageCount: 'one:uusi sivu|other:uutta sivua',
  changedPageCount: 'one:muuttunut sivu|other:muuttunutta sivua',
  otherSectionCount: 'one:muu osio|other:muuta osiota',
  characterCount: 'one:merkki|other:merkkiä',
  diffStats: '{sections} muutettu · {added} lisätty · {removed} poistettu',
  diffMatchesBase: 'Ehdotettu teksti vastaa pohjaversiota.',
  diffIntroduction: 'Johdanto',
  diffOtherUnchanged: '{sections} ennallaan.',
  timeJustNow: 'juuri nyt',
  originImportedFrom: 'Tuotu lähteestä {path}',
  originImportedFromCommit: 'Tuotu lähteestä {path} @ {commit}',
  authorityApprovedInPoneva: 'Hyväksytty Ponevassa',
  authorityImported: 'Tuotu',
  authorityInRepository: '{canonicality} repositoriossa',
  authorityVerified: 'vahvistettu {date}',
  authorRepositoryImport: 'Tuonti repositoriosta',
  authorSuggestedInChat: 'Ehdotettu keskustelussa',
  authorSuggestedInChatWith: 'Ehdotettu keskustelussa käyttäjän {name} kanssa',
  authorSuggestedBy: 'Ehdottaja: {name}',
  authorSuggestedByApp: 'Ehdottanut yhdistetty sovellus',
  authorSuggestedByColleague: 'Ehdottanut kollega',
  authorSuggestedByYou: 'Ehdottanut sinä',
  authorSuggestedOnBehalf: 'Ehdottaja: {app} käyttäjän {name} puolesta',
  authorSuggestedByAppOnBehalf: 'Ehdottanut yhdistetty sovellus käyttäjän {name} puolesta',
  authorSuggestedAndApproved: 'Ehdottanut ja hyväksynyt: {name}',
  approverApprovedBy: 'hyväksyjä: {name}',
  approverAppliedBy: 'käyttöönottaja: {name}',
  kindCreatePage: 'Uusi sivu',
  kindUpdatePage: 'Ehdotettu päivitys',
  kindArchivePage: 'Arkistointi',
  statusConflict: 'Ristiriita · sivu muuttunut',
  statusPending: 'Odottaa tarkistusta',
  statusApproved: 'Hyväksytty',
  statusRejected: 'Hylätty',
  statusWithdrawn: 'Peruttu',
  statusSuperseded: 'Korvattu',
  errRevisionConflict: 'Tämä sivu muuttui, kun tarkistit sitä.',
  errProposalChanged:
    'Tämä ehdotus muuttui, kun tarkistit sitä. Tarkista uusin versio ennen päätöstä.',
  errPublishRequired:
    'Vain yrityksen julkaisijat voivat hyväksyä tietämyksen muutoksia tai tuoda sivuja.',
  errProposalLimit:
    'Yritykselläsi on jo 200 ehdotusta odottamassa tarkistusta. Käsittele osa niistä ennen kuin ehdotat lisää.',
  errAuthorLimit:
    'Sinulla on jo 50 ehdotusta odottamassa tarkistusta. Odota, että osa niistä ratkaistaan, tai peru joitakin ennen kuin ehdotat lisää.',
  errImportProposalLimit:
    'Tämä tuonti lisäisi tarkistettavaksi enemmän muuttuneita sivuja kuin yrityksesi tarkistusjonoon mahtuu (enintään 200). Ratkaise osa ehdotuksista kohdassa Tarkistettavana ja ota tuonti sitten uudelleen käyttöön.',
  errImportChanged:
    'Tämä ei ole se tuonti, jonka tarkistit. Avaa se uudelleen ja tarkista se ennen käyttöönottoa.',
  errImportItemNotFound: 'Tämä dokumentti ei ole enää osa tuontia.',
  errIdempotencyConflict:
    'Tämä ehdotus on jo lähetetty eri sisällöllä. Lataa sivu uudelleen ja yritä uudelleen.',
  errImportHashMismatch:
    'Tilannevedoksen tiedosto ei vastaa sen tallennettua tarkistussummaa. Luo uusi tilannevedos ja yritä uudelleen.',
  errImportAlreadyApplied: 'Tämä tuonti on jo otettu käyttöön.',
  errImportDiscarded: 'Tämä tuonti hylättiin. Valitse tilannevedostiedosto uudelleen.',
  errImportDuplicateItem:
    'Tässä tilannevedoksessa sama dokumentti on kahdesti. Luo tilannevedos uudelleen.',
  errInvalidImport:
    'Poneva ei voinut hyväksyä tätä tilannevedosta. Luo uusi tilannevedosskriptillä ja yritä uudelleen.',
  errInvalidInput: 'Poneva ei voinut hyväksyä näitä tietoja. Tarkista kentät ja yritä uudelleen.',
  errImportLimit:
    'Liian monta tuontia odottaa käyttöönottoa. Ota käyttöön tai hylkää joitakin ennen kuin valmistelet uuden.',
  errPageTooLarge: 'Sivu on suurempi kuin 256 kt. Jaa se pienempiin sivuihin.',
  errTooManySections: 'Sivulla on yli 2 000 otsikkoa. Jaa se pienempiin sivuihin.',
  errPageLimit: 'Yrityksesi on saavuttanut 2 000 tietosivun rajan.',
  errCollectionLimit: 'Yrityksesi on saavuttanut 100 aiheen rajan.',
  errProposalNotPending: 'Tästä ehdotuksesta on jo päätetty. Näytetty tila on ajan tasalla.',
  errRequesterRemoved:
    'Ehdotuksen tekijä ei kuulu enää tähän yritykseen, joten ehdotusta ei voi hyväksyä.',
  errRevisionAlreadyCurrent: 'Tämä versio on jo nykyinen versio.',
  errPageArchived:
    'Tämä sivu arkistoitiin, kun tarkistit sitä. Tarkista ehdotus uudelleen ennen päätöstä.',
  errAlreadyArchived: 'Tämä sivu on jo arkistoitu.',
  errProposalForbidden: 'Vain ehdotuksen tekijä voi perua sen.',
  errUnavailable: 'Tietosivut eivät ole juuri nyt käytettävissä.',
  errTimeout: 'Ponevan vastaus kesti liian kauan.',
  errItemTooLarge: '{path} on suurempi kuin 256 kt. Jaa se pienempiin sivuihin.',
  errItemTooManySections: 'Tiedostossa {path} on yli 2 000 otsikkoa. Jaa se pienempiin sivuihin.',
  errItemHashMismatch:
    '{path} ei vastaa tallennettua tarkistussummaansa. Luo uusi tilannevedos ja yritä uudelleen.',
  errNoLongerAvailable: 'Tämä kohde ei ole enää käytettävissäsi.',
  errTooLargeToSend: 'Tiedosto on liian suuri lähetettäväksi.',
  cardChecking: 'Tarkistetaan tilaa…',
  cardNotAvailable: 'Ei käytettävissä',
  cardStatusUnavailable: 'Tila ei saatavilla',
  cardUnshowable: 'Tätä ehdotettua tietomuutosta ei voitu näyttää.',
  cardEyebrow: 'Ehdotettu tietomuutos',
  cardLabel: 'Ehdotettu tietomuutos · {title}',
  cardMissing: 'Tämä ehdotus ei ole enää käytettävissäsi.',
  cardUnknown: 'Emme voineet tarkistaa ehdotuksen tilannetta. Avaa tarkistus nähdäksesi sen tilan.',
  cardCheckAgain: 'Tarkista uudelleen',
  cardReview: 'Tarkista muutos',
  statusLineApproved: 'Hyväksytty tietämys',
  readyCount: 'one:valmiina hakuun|other:valmiina hakuun',
  preparingCount: 'one:valmisteilla|other:valmisteilla',
  attentionCount: 'one:vaatii huomiota|other:vaatii huomiota',
  topicsExplore: 'Tutustu aiheeseen',
  topicsAllPages: 'Kaikki sivut',
  topicsOpenPages: 'Avaa Sivut',
  topicsEmpty:
    'Hyväksyttyjä sivuja ei ole vielä. Sivuilla on yrityksen laajempi tietämys ja sen koko versiohistoria.',
  reviewsTitle: 'Ehdotetut sivumuutokset',
  reviewsTitleMine: 'Ehdottamasi sivumuutokset',
  reviewsIntro:
    'Jokainen ehdotus on kokonainen versioehdokas perusteluineen ja todisteineen. Mikään ei muutu, ennen kuin hyväksyt juuri sen version.',
  reviewsIntroMine:
    'Ehdotuksesi odottavat täällä, kunnes yrityksen julkaisija tarkistaa ne. Sivut pysyvät siihen asti ennallaan.',
  loadPagesFailed: 'Tietosivuja ei voitu ladata.',
  loadProposalsFailed: 'Ehdotettuja sivumuutoksia ei voitu ladata.',
  loadMoreFailed: 'Lisää sivuja ei voitu ladata.',
  otherPages: 'Muut sivut',
  loadTopicFailed: 'Tätä aihetta ei voitu ladata.',
  revisionShort: 'v{n}',
  updatedOn: 'Päivitetty {date}',
  emptyTitle: 'Tietosivuja ei ole vielä.',
  emptyBody:
    'Sivuilla on yrityksesi hyväksytty, laajempi tietämys – suunta, päätökset ja toimintatavat – ja jokainen versio säilyy. Tuo sivut repositorion tilannevedoksesta tai aloita sivu keskustelussa; julkaisija hyväksyy jokaisen sivun ennen kuin se lasketaan yrityksen tietämykseksi.',
  importFromSnapshot: 'Tuo repositorion tilannevedoksesta',
  startInChat: 'Aloita sivu keskustelussa',
  startInChatPrompt:
    'Auta minua aloittamaan tietosivu yrityksellemme. Kysy, mitä sen pitäisi kattaa, äläkä keksi sisältöä. Sivu pysyy ehdotuksena, kunnes yrityksen julkaisija hyväksyy sen.',
  loadingPages: 'Ladataan tietosivuja…',
  filterLabel: 'Suodata sivuja otsikon mukaan',
  filterPlaceholder: 'Suodata sivuja',
  importButton: 'Tuo',
  showingTopic: 'Näytetään {topic}',
  showAllTopics: 'Näytä kaikki aiheet',
  loadingTopic: 'Ladataan aihetta…',
  noMatch: 'Mikään sivu ei vastaa hakua ”{filter}”.',
  topicNoPages: 'Tässä aiheessa ei ole vielä hyväksyttyjä sivuja.',
  loading: 'Ladataan…',
  loadMore: 'Lataa lisää sivuja',
  metaApproved: 'hyväksytty {date}',
  metaRepositoryAuthoritative: 'repositorio on yhä ensisijainen lähde',
  loadPageFailed: 'Tätä sivua ei voitu ladata.',
  loadHistoryFailed: 'Versiohistoriaa ei voitu ladata.',
  outlineLabel: 'Sivun osiot',
  outlineToggle: 'Tällä sivulla',
  loadingHistory: 'Ladataan versiohistoriaa…',
  historyLabel: 'Versiohistoria',
  historyIntro:
    'Jokainen hyväksytty versio säilytetään. Aiemman version palauttaminen luo tarkistettavan ehdotuksen; se ei koskaan poista myöhempiä versioita.',
  historyCurrent: 'Nykyinen',
  historyViewing: 'Näkymässä',
  historyView: 'Näytä',
  historyViewAria: 'Näytä versio {n}',
  restoreAria: 'Palauta ehdotuksena: versio {n}',
  restoreCreating: 'Luodaan ehdotusta…',
  restore: 'Palauta ehdotuksena',
  restoreUnconfirmed:
    'Emme voineet vahvistaa, että ehdotus luotiin. Tarkista kohta Tarkistettavana ennen kuin yrität uudelleen.',
  editTooLarge:
    'Tämä sivu on suurempi kuin 256 kt. Jaa se pienempiin sivuihin ennen kuin ehdotat sitä.',
  editConflict:
    'Tämä sivu muuttui muokkauksesi aikana. Kopioi tekstisi, avaa uusin versio ja ehdota muokkausta uudelleen.',
  editUnconfirmed:
    'Emme voineet vahvistaa, että ehdotuksesi lähetettiin. Tarkista kohta Tarkistettavana ennen kuin lähetät sen uudelleen.',
  editHeading: 'Ehdota muokkausta',
  editIntro:
    'Muokkaat versiota {n}. Yrityksen julkaisija tarkistaa tarkan muutoksen ennen kuin siitä tulee versio {next}; siihen asti sivu pysyy ennallaan.',
  editOutdated:
    'Uudempi versio hyväksyttiin muokkauksesi aikana. Kopioi tekstisi ja aloita uudelleen uusimmasta versiosta, jotta sen muutokset eivät katoa.',
  editContentLabel: 'Sivun sisältö (Markdown)',
  editReasonLabel: 'Miksi tämä muutos?',
  editReasonPlaceholder: 'Mitä muuttui ja mistä tieto on peräisin.',
  editSending: 'Lähetetään…',
  editSend: 'Lähetä tarkistettavaksi',
  editDiscardConfirm: 'Hylätäänkö tämä muokkaus? Mitään muutoksistasi ei ole lähetetty.',
  editNoChanges: 'Ei vielä muutoksia.',
  editNeedsContent: 'Sivulla on oltava sisältöä.',
  exportFailed: 'Tätä sivua ei voitu viedä. Yritä uudelleen.',
  askPagePrompt: 'Kysymys tietosivusta ”{title}” (versio {n}, {link}):',
  askPageSectionPrompt: 'Kysymys tietosivun ”{title}” kohdasta § {section} (versio {n}, {link}):',
  pageMissingTitle: 'Tämä sivu ei ole käytettävissä.',
  pageMissingBody:
    'Se on ehkä arkistoitu, tai sinulla ei ehkä ole enää pääsyä tämän yrityksen tietämykseen.',
  pageArchived: 'Arkistoitu',
  viewingRevisionCurrent: 'Katselet versiota {n}; nykyinen versio on {current}.',
  viewingRevisionOld: 'Katselet versiota {n}. Se ei ole nykyinen versio.',
  openCurrent: 'Avaa nykyinen',
  archivedBanner:
    'Tämä sivu on arkistoitu. Sitä ei enää käytetä vastauksissa; sen historia säilyy.',
  pageViewsLabel: 'Sivun näkymät',
  tabRead: 'Lue',
  tabHistory: 'Historia',
  unknownSection: 'Linkitetty osio ei kuulu tähän versioon. Näytetään koko sivu.',
  askAboutPage: 'Kysy tästä sivusta',
  exporting: 'Viedään…',
  exportMarkdown: 'Vie Markdown-muodossa',
  loadSuggestionFailed: 'Tätä ehdotusta ei voitu ladata.',
  evidenceSource: 'Lähde',
  evidenceFact: 'Yrityksen taustatieto',
  evidenceResult: 'Tallennettu työ',
  evidenceUrl: 'Verkkosivu',
  evidenceDecision: 'Päätös',
  evidenceReference: 'Viite',
  evidenceOpenPage: 'Avaa tietosivu',
  evidenceOpenSource: 'Avaa lähde',
  evidenceOpenFact: 'Avaa yrityksen taustatieto',
  evidenceOpenResult: 'Avaa tallennettu työ',
  evidenceOpenUrl: 'Avaa verkkosivu',
  evidenceOpenDecision: 'Avaa päätös',
  evidenceOpenReference: 'Avaa viite',
  evidenceDecisionNote: 'Kirjattu päätös. Ponevassa ei ole mitään avattavaa.',
  evidenceFactGone: 'Tätä yrityksen taustatietoa ei ole enää tallennettu.',
  evidencePageNoRevision: 'Tällä sivulla ei ole hyväksyttyä versiota avattavaksi.',
  evidencePrivateExcerpt: 'Yksityinen todiste – vain yllä oleva ote jaettiin.',
  evidencePrivate: 'Yksityinen todiste – sen sisältöä ei jaettu kanssasi.',
  evidenceHeading: 'Todisteet',
  evidenceNone: 'Todisteita ei liitetty. Arvioi yllä oleva perustelu sellaisenaan.',
  changeAdded: 'Lisätty',
  changeRemoved: 'Poistettu',
  changeChanged: 'Muutettu',
  changeUnchanged: 'Ennallaan',
  moreLineCount: 'one:muu rivi|other:muuta riviä',
  moreUnchangedLineCount: 'one:muu muuttumaton rivi|other:muuta muuttumatonta riviä',
  unchangedLineCount: 'one:muuttumaton rivi|other:muuttumatonta riviä',
  skipAdded: '{lines} – näkyvät kokonaisessa versiossa',
  skipRemoved: '{lines} poistettu',
  cutUnchanged: '{lines} ei näytetä',
  cutChanged: '{lines} ei näytetä, {changes}. Tarkista ne kokonaisesta versiosta.',
  cutAddedRemoved: '{added} lisätty ja {removed} poistettu',
  cutAdded: '{added} lisätty',
  cutRemoved: '{removed} poistettu',
  lineAddedSr: 'Lisätty:',
  lineRemovedSr: 'Poistettu:',
  noLinesAdded: 'Uusi osio. Sen teksti on alla olevassa kokonaisessa versiossa.',
  noLinesRemoved: 'Tämä osio poistettaisiin sivulta.',
  noLinesChanged: 'Tämä osio muuttuu. Sen teksti on alla olevassa kokonaisessa versiossa.',
  diffHeading: 'Muutokset',
  outcomeArchived: 'Arkistoitu.',
  outcomeArchivedBody:
    'Sivua {title} ei enää käytetä vastauksissa, ja se on poistunut sivuluettelosta. Sen versiot, tämä ehdotus ja päätös säilyvät sivun historiassa.',
  openArchivedPage: 'Avaa arkistoitu sivu',
  outcomeApproved: 'Hyväksytty.',
  outcomeApprovedRevision: 'Versio {n} on nyt sivun {title} hyväksytty versio.',
  outcomeApprovedPlain: 'Tämä ehdotus hyväksyttiin.',
  outcomeRestored: 'Sivu on taas sivuluettelossa ja käytössä vastauksissa.',
  outcomeKept: 'Ehdotus, päätös ja kaikki aiemmat versiot säilyvät sivun historiassa.',
  openPage: 'Avaa sivu',
  outcomeDismissed: 'Hylätty.',
  outcomeWithdrawn: 'Peruttu.',
  outcomeSuperseded: 'Korvattu.',
  outcomeSupersededBody:
    'Uudempi versio, ehdotus tai repositoriotuonti teki tästä ehdotuksesta vanhentuneen. Se ei itsessään muuttanut mitään.',
  outcomeUnchanged: 'Sivu pysyy ennallaan.',
  approveNewPage: 'Hyväksy uusi sivu',
  approveArchive: 'Hyväksy arkistointi',
  approveRestoreRevision: 'Palauta ja hyväksy versio {n}',
  approveRevision: 'Hyväksy versio {n}',
  approveArchiveNote: 'Kun hyväksyt, sivu arkistoidaan ja koko {company} näkee sen arkistoituna.',
  approvePublishNote: 'Kun hyväksyt, tämä versio julkaistaan ja koko {company} näkee sen.',
  approvePublishEvidenceNote:
    'Kun hyväksyt, tämä versio ja yllä näkyvät todisteotteet julkaistaan, ja koko {company} näkee ne.',
  archivedTitle: 'Tämä sivu on arkistoitu.',
  alreadyArchivedBody: 'Hyväksyminen ei muuttaisi mitään, joten tämän ehdotuksen voi vain hylätä.',
  archivedRestoreBody:
    'Hyväksyminen palauttaa sivun: se palaa sivuluetteloon, hakuun ja vastauksiin tällä versiolla.',
  staleRevisionAction: 'Vertaa uusimpaan versioon',
  staleProposalTitle: 'Tämä ehdotus muuttui, kun tarkistit sitä.',
  staleProposalAction: 'Tarkista uusin versio',
  staleArchivedTitle:
    'Tämä sivu arkistoitiin, kun tarkistit sitä. Tämän ehdotuksen hyväksyminen palauttaisi sen.',
  staleArchivedAction: 'Tarkista uudelleen',
  suggestionMissingTitle: 'Tämä ehdotus ei ole käytettävissä.',
  suggestionMissingBody:
    'Se on ehkä peruttu, tai se kuuluu jollekulle toiselle eikä sitä ole lähetetty yrityksen tarkistettavaksi.',
  decideUnconfirmed:
    'Emme voineet vahvistaa päätöstäsi. Näytetty tila on Ponevan uusin tieto; tarkista se ennen kuin yrität uudelleen.',
  decideFailed: 'Päätöstäsi ei voitu tallentaa.',
  discussPrompt: 'Auta minua hiomaan ehdotettua tietomuutosta sivuun ”{title}” ({link}).',
  conflictBody:
    'Tämä ehdotus on tehty versioon {base}; nykyinen versio on {current}. Hyväksyminen kumoaisi tuon muutoksen, joten ehdotusta ei voi hyväksyä sellaisenaan.',
  conflictBodyPlain:
    'Tämä ehdotus on tehty aiempaan versioon, joten sitä ei voi hyväksyä sellaisenaan.',
  openLatest: 'Avaa uusin versio',
  reworkInChat: 'Muokkaa keskustelussa',
  factReason: 'Perustelu',
  factNoReason: 'Perustelua ei annettu.',
  factAudience: 'Yleisö',
  factRevision: 'Versio',
  revisionNew: 'Uusi sivu, versio 1',
  revisionArchiveAfter: 'Arkistoi version {n} jälkeen',
  revisionWrittenAgainst: 'Tehty versioon {base}; nykyinen versio on {current}',
  revisionCurrentToProposed: 'Nykyinen versio {base} → ehdotettu versio {next}',
  revisionProposed: 'Ehdotettu versio {next}',
  proposedPage: 'Ehdotettu sivu',
  archivingHeading: 'Mitä arkistointi tekee',
  archivingBody:
    'Sivua ei enää käytetä vastauksissa, ja se poistuu sivuluettelosta. Sen versiot ja tämä päätös säilyvät.',
  noComparison: 'Tälle ehdotukselle ei ole saatavilla osiovertailua.',
  showComplete: 'Näytä kokonainen versio',
  approving: 'Hyväksytään…',
  dismissing: 'Hylätään…',
  dismiss: 'Hylkää',
  withdrawing: 'Perutaan…',
  withdraw: 'Peru',
  editInChat: 'Muokkaa keskustelussa',
  waitingForPublisher: 'Odottaa, että yrityksen julkaisija tarkistaa sen.',
  snapshotTooLarge: 'Tämä tilannevedos on suurempi kuin 8 Mt. Luo se vähemmillä dokumenteilla.',
  snapshotNotSnapshot:
    'Tämä tiedosto ei ole tietämyksen tilannevedos. Valitse JSON-tiedosto, jonka tilannevedosskripti kirjoitti.',
  snapshotEmpty: 'Tässä tilannevedoksessa ei ole dokumentteja.',
  readDocumentFailed: 'Tätä dokumenttia ei voitu lukea. Yritä uudelleen.',
  readingDocument: 'Luetaan dokumenttia…',
  hideText: 'Piilota teksti',
  readText: 'Lue teksti',
  textOf: 'Dokumentin {title} teksti',
  gitSnapshot: 'Git-tilannevedos {commit}',
  repositorySnapshot: 'Repositorion tilannevedos',
  importNewHeading: '{pages} · hyväksytään, kun otat tuonnin käyttöön',
  importNewNote:
    'Jokainen julkaistaan hyväksyttynä sivuna ilman lisätarkistusta, ja koko {company} näkee sen. Lue jokainen ennen kuin otat tuonnin käyttöön.',
  importChangedHeading: '{pages} · lähetetään tarkistettavaksi',
  importChangedNote:
    'Jokaisesta tulee ehdotettu muutos. Sen sivu muuttuu vasta, kun julkaisija hyväksyy sen kohdassa Tarkistettavana, jossa näkyy, mitä muuttui.',
  unchangedDocumentCount: 'one:muuttumaton dokumentti|other:muuttumatonta dokumenttia',
  unchangedNote: 'Nämä vastaavat jo hyväksyttyjä sivujaan. Niistä ei kirjoiteta mitään.',
  stagedHeading: 'Valmisteltu, ei otettu käyttöön',
  excludedSummary: '{documents} jätetty pois tästä tilannevedoksesta',
  countsLine: '{newPages} · {changedPages} tarkistettavaksi · {unchanged} ennallaan',
  importAlreadyDiscarded: 'Tämä tuonti on jo hylätty.',
  confirmLabel: 'Vahvista tuonti',
  unchangedKeepCount:
    'one:muuttumaton dokumentti säilyttää sivunsa|other:muuttumatonta dokumenttia säilyttää sivunsa',
  confirmBody:
    'Otetaanko tämä tuonti käyttöön? Koko {company} näkee tuloksen: {newPages} hyväksytään versiona 1, {changedPages} odottaa tarkistusta, ja {unchanged}. Näiden sivujen aiemmat tuontiehdotukset perutaan.',
  applying: 'Otetaan käyttöön…',
  applyImport: 'Ota tuonti käyttöön',
  chooseAnother: 'Valitse toinen tiedosto',
  allCurrent: 'Kaikki tämän tilannevedoksen sisältö on jo ajan tasalla.',
  importApplied: 'Tuonti otettu käyttöön.',
  appliedSummary: '{pages} luotu · {changes} odottaa tarkistusta · {unchanged} ennallaan.',
  appliedIndexing:
    'Uudet sivut ovat haettavissa keskustelussa, kun indeksointi on valmis. Lähteiden valmistelu näyttää edistymisen.',
  openPages: 'Avaa sivut',
  reviewChanges: 'Tarkista {changes}',
  checkIndexing: 'Tarkista indeksoinnin edistyminen',
  sendSnapshotFailed: 'Tätä tilannevedosta ei voitu lähettää. Yritä uudelleen.',
  openStagedFailed: 'Tätä valmisteltua tuontia ei voitu avata.',
  applyUnconfirmed:
    'Emme voineet vahvistaa, otettiinko tuonti käyttöön. Tarkista Sivut ennen kuin yrität uudelleen.',
  applyFailed: 'Tätä tuontia ei voitu ottaa käyttöön.',
  importHeading: 'Tuo sivuja repositoriosta',
  backToPages: 'Takaisin sivuihin',
  importLead:
    'Luo tilannevedos komennolla {command} ja valitse sitten tiedosto. Näet jokaisen dokumentin ja sen, mitä se muuttaisi, ennen kuin mitään tallennetaan.',
  snapshotFileLabel: 'Tietämyksen tilannevedostiedosto',
  readingSnapshot: 'Luetaan tilannevedosta…',
  openingStaged: 'Avataan valmisteltua tuontia…',
  chooseSnapshot: 'Valitse tilannevedostiedosto',
  factOrigin: 'Alkuperä',
  factContents: 'Sisältö',
  importOnlyListed: 'Vain tässä luetellut dokumentit tuodaan.',
  importRepositoryAuthoritative:
    'Repositorio pysyy ensisijaisena lähteenä; muuttuneista dokumenteista tulee tarkistettavia ehdotuksia.',
  overviewReviewChanges: 'Tarkista muutokset',
  overviewConnectAgents: 'Yhdistä ulkoisia agentteja',
  overviewEyebrow: 'Yhteinen ymmärrys',
  overviewTitle: '{company} kokonaisuutena.',
  overviewLeadFallback:
    'Yrityksesi tietämys alkaa jakamistasi taustatiedoista. Rakennetaan yhdessä ymmärrys liiketoiminnastasi.',
  overviewBody:
    'Yrityksen taustatiedot ja lähdeaineisto antavat Ponevalle lähtökohdan – eivät kaikkea, mitä yrityksestä {company} on tiedettävä. Jatka tämän ymmärryksen kartuttamista liiketoimintasi kehittyessä.',
  overviewAskPrompt: 'Mitä tiedät yrityksestämme, ja mitä olisi hyödyllistä lisätä?',
  overviewAsk: 'Kysy yrityksestä {company}',
  overviewAddSources: 'Lisää lähteitä',
  contextEyebrow: 'Mikä antaa vastauksille taustaa',
  contextTitle: 'Kysymyksen takana oleva liiketoiminta.',
  contextBody:
    'Verkkosivulähteet kuvaavat julkista liiketoimintaa. Yrityksen muistiinpanot lisäävät yrityksesi terminologian, prioriteetit ja toimintatavat.',
  contextPrompt:
    'Auta minua selkeyttämään yrityksemme prioriteetit ja työskentelytavat, jotka meidän pitäisi muistaa.',
  contextAction: 'Rakenna ymmärrystämme',
  learnEyebrow: 'Tilaa oppia',
  learnTitle: 'Aloita siitä, mikä on seuraavaksi tärkeintä.',
  learnBody:
    'Tuo lähdeaineistoa tai selkeytä, miten yrityksesi toimii. Poneva voi ehdottaa pysyviä muutoksia, jotka voit tarkistaa.',
  learnPrompt:
    'Mitä tärkeää tietoa yrityksemme nykyisestä tietämyksestä puuttuu työhön, jota haluamme tehdä?',
  learnAction: 'Keskustele siitä, mikä olisi hyödyllistä',
  canvasEmptyTitle: 'Vähäkin taustatieto auttaa paljon.',
  canvasEmptyBody:
    'Yritysprofiilisi on lähtökohta. Lisää lähdeaineistoa ja tarkistettuja muistiinpanoja, jotta Poneva ymmärtää työtäsi.',
  pageEyebrow: 'Työtila: {company}',
  pageTitle: 'Yrityksen tietämys',
  pageDescription: 'Lähteet ja ymmärrys Ponevan työn taustalla.',
  tabOverview: 'Yleiskatsaus',
  tabPages: 'Sivut',
  tabSources: 'Lähteet',
  tabReview: 'Tarkistettavana',
  proposalApproved: 'Hyväksytty yrityksen taustatieto',
  proposalDismissed: 'Hylätty ehdotus',
  proposalRemoval: 'Ehdotettu poisto',
  proposalCorrection: 'Ehdotettu korjaus',
  proposalContext: 'Ehdotettu yrityksen taustatieto',
  proposalCurrent: 'Nykyinen ymmärrys',
  proposalFactGone:
    'Tallennettu tieto ei ole enää käytettävissä. Päivitä yrityksen tietämys ennen kuin tarkistat tämän poiston.',
  proposalReviewFallback: 'Tarkista ehdotettu yrityksen taustatieto.',
  proposalNotSaved: 'Ei vielä tallennettu. Alkuperäiset lähteet pysyvät ennallaan.',
  proposalWaiting: 'Odottaa tarkistusta · julkaisija päättää Saapuneet-näkymässään',
  proposalSaving: 'Tallennetaan…',
  proposalApproveRemoval: 'Hyväksy poisto',
  proposalApproveClarification: 'Hyväksy tarkennus',
  factLabel: 'Yritystieto',
  factEyebrow: 'Tieto · Koko {company}',
  factSuggestCorrection: 'Ehdota korjausta',
  factAskPrompt:
    'Auta minua ymmärtämään tai tarkentamaan tätä tallennettua yrityksen taustatietoa: ”{content}”',
  factAsk: 'Kysy tästä',
  companyContextHeading: 'Yrityksen taustatiedot',
  companyContextPrompt:
    'Haluan tarkentaa yrityksemme tietämystä. Auta minua käymään läpi, mitä tiedämme, ja ehdottamaan päivitystä.',
  companyContextEmpty:
    'Hyväksyttyjä muistiinpanoja ei ole vielä. Aloita keskustelu yrityksestäsi tai lisää lähdeaineistoa alla.',
  refineInChat: 'Hio keskustelussa',
  reviewPanelLabel: 'Tarkistettavat tietämyksen muutokset',
  suggestedUpdatesHeading: 'Ehdotetut päivitykset',
  suggestedUpdatesIntro:
    'Ehdotuksia keskusteluistasi. Sinä päätät, mistä tulee pysyvä osa yrityksesi tietämystä.',
  reviewEmptyTitle: 'Mikään ei odota tarkistustasi.',
  reviewEmptyBody:
    'Kun Poneva ehdottaa muutosta yrityksesi tietämykseen, löydät sen täältä. Pysyvät muutokset vaativat aina hyväksyntäsi.',
  reviewEmptyPrompt:
    'Auta minua käymään läpi yrityksemme tietämys ja ehdota, mitä olisi hyödyllistä tarkentaa seuraavaksi.',
  inclusionPendingApproval: 'Tietämykseen sisällyttämisen muutos lähetettiin hyväksyttäväksi.',
  sourcesFileIncluded: 'Tiedosto sisällytettiin tietämyshakuun sen nykyiselle yleisölle.',
  sourcesAddFailed: 'Tätä lähdettä ei voitu lisätä.',
  sourcesHeading: 'Aineisto vastausten takana.',
  sourcesIntro:
    'Poneva hakee koko lähdeaineistosta, ei vain yleiskatsauksesta. Säilytä alkuperäiset, katso, mikä on valmiina, ja valitse, mikä vaikuttaa vastauksiisi.',
  addSourceHeading: 'Lisää aineistoa yrityksestäsi',
  addSourceIntro:
    'Ladatut lähteet pysyvät yksityisinä Kirjastossasi ja vaikuttavat vain omiin vastauksiisi. Valitse Jaa, kun haluat antaa ne kollegoidesi käyttöön.',
  uploadSource: 'Lataa lähde',
  addSourcePrompt:
    'Auta minua lisäämään yrityksen kannanotto jaetuksi sisäiseksi lähteeksi. Kysy, mitä haluan kirjata, äläkä keksi sisältöä. Pysyvät muutokset yrityksen ymmärrykseen vaativat edelleen hyväksyntäni.',
  addThroughChat: 'Lisää keskustelussa',
  addingSource: 'Lisätään…',
  addToKnowledge: 'Lisää tietämykseen',
  uploadFormats: 'TXT, Markdown, CSV ja JSON · Enintään 5 Mt tiedostoa kohden',
  sourceExcluded: 'Jätetty pois vastauksista',
  sourcePreparationFailed: 'Valmistelu epäonnistui',
  sourcePreparing: 'Valmistellaan hakua varten',
  sourceWaiting: 'Odottaa valmistelua',
  sourceReadinessUnknown: 'Valmiustieto ei ole saatavilla',
  sourceRetryQueued: 'Valmistelu on jonossa. Valmiustieto päivittyy, kun se on valmis.',
  sourceIncludedNotice: 'Lähde sisällytettiin. Poneva valmistelee sen hakua varten.',
  sourceExcludedNotice: 'Jätetty pois vastauksista. Alkuperäinen lähde säilytetään.',
  sourceUpdateFailed: 'Tätä lähdettä ei voitu päivittää.',
  sourceOriginalMaterial: 'Alkuperäinen lähdeaineisto',
  sourceDiscuss: 'Käsittele keskustelussa',
  sourceDiscussPrompt: 'Auta minua ymmärtämään tai tarkentamaan lähdettä ”{title}”.',
  sourceExclude: 'Jätä pois vastauksista',
  sourceInclude: 'Sisällytä vastauksiin',
  sourcesLoadFailed: 'Lähteitäsi ei voitu ladata.',
  sourceLibraryLabel: 'Yrityksen lähdekirjasto',
  sourceListCaption: 'Alkuperäiset lähteet · sisällytetyt ja pois jätetyt',
  sourceSearchLabel: 'Hae yrityksen lähteistä',
  sourceSearchPlaceholder: 'Hae lähteistäsi…',
  sourcesFinding: 'Etsitään lähteitäsi…',
  sourcePagesLabel: 'Lähdesivut',
  sourceRange: '{from}–{to} / {count}',
  sourceCount: 'one:lähde|other:lähdettä',
  sourcePrevious: 'Edellinen',
  sourceNext: 'Seuraava',
  sourceNoMatchTitle: 'Ei vastaavia lähteitä.',
  sourceNoMatchBody: 'Kokeile toista ilmausta tai lähteen nimeä.',
  sourceEmptyTitle: 'Anna kysymyksillesi vahvempi lähtökohta.',
  sourceEmptyBody:
    'Lisää yrityksen dokumentteja, tuotetietoja tai työmuistiinpanoja. Poneva voi käyttää koko lähdeaineistoa keskusteluissa ja Skilleissä.',
  indexCheckFailed: 'Lähteiden valmistelua ei voitu tarkistaa.',
  indexRetryQueued:
    'Epäonnistuneet tietämysmerkinnät on lisätty valmistelujonoon. Lähdeaineistosi pysyy ennallaan.',
  indexQueueFailed: 'Valmistelua ei voitu lisätä jonoon. Yritä uudelleen.',
  indexPreparing: 'Valmistellaan uutta tietämystä keskusteluihisi…',
  indexAttention: 'Osa tietämyksestä vaatii huomiota.',
  queuing: 'Lisätään jonoon…',
  retryPreparation: 'Yritä valmistelua uudelleen',
  sourceKindStatement: 'Yrityksen kannanotto',
  sourceKindWebsite: 'Verkkosivusto',
  sourceKindDocument: 'Dokumentti',
  factAnswers: 'one:vastaus|other:vastausta',
  factUsedThisWeek: 'Käytetty tällä viikolla: {answers}',
  factLastUsed: 'viimeksi käytetty: {when}',
  factToday: 'tänään',
  factYesterday: 'eilen',
  factImpact: 'Muutos vaikuttaa yrityksen tietoon, jota käytettiin tällä viikolla ({answers}).',
  factCorrectionAbout: 'Tästä yrityksen tiedosta: ”{content}” ({link})',
  factCorrectionOutdated: 'Tämä on vanhentunut:',
  sourceCanvasRecorded: 'Tallennettu lähdeaineisto',
  sourceCanvasNotIncluded:
    'Ei sisälly yrityksen tietämykseen. Alkuperäinen säilytetään viitteeksi, ja sitä voi yhä käyttää yksittäisessä keskustelussa.',
  sourceCanvasOpenOriginal: 'Avaa alkuperäinen lähde',
  sourceCanvasUnavailable: 'Lähteen sisältö ei ole saatavilla.',
  sourceCanvasDiscussPrompt: 'Auta minua ymmärtämään tai selventämään lähdettä ”{title}”.',
  sourceCanvasDiscuss: 'Keskustele tästä lähteestä',
  sourceCanvasCorrectionNote:
    'Korjauksesta tulee ehdotettu yrityksen taustatieto. Tallennettu lähde pysyy muuttumattomana.',
  contextCanvasEyebrow: 'Käytettävissä oleva yrityksen taustatieto',
  contextCanvasTitle: 'Tämän keskustelun taustalla oleva tietämys.',
  contextCanvasBody:
    'Hyväksytty tietämys ja yrityksesi lisäämä lähdeaineisto. Käytettävissä keskustelussa ja Skills-toiminnossa.',
  contextCanvasOpen: 'Avaa Tietämys',
};

export default fi;
